// The last complete Findings reads for each view (scope, range and search),
// kept in memory so a return to the page shows them at once while the page
// reads again, instead of an empty list for as long as the reads take. Kept
// for KEEP_MS at most, for the few views read last, and only under the
// sign-in they were read with: any change to it drops them all.
import { getAuthContextEpoch, onAuthContextChange } from "./authTokenStore.js";

export const KEEP_MS = 15 * 60 * 1000;
const MAX_KEPT = 4;
const kept = new Map();
onAuthContextChange(() => kept.clear());

const keyOf = (key) => `${getAuthContextEpoch()}|${key}`;

export function keepReads(key, reads, nowMs = Date.now()) {
    const k = keyOf(key);
    kept.delete(k);
    kept.set(k, { reads, atMs: nowMs });
    while (kept.size > MAX_KEPT) kept.delete(kept.keys().next().value);
}

export function keptReads(key, nowMs = Date.now()) {
    const entry = kept.get(keyOf(key));
    if (!entry) return null;
    if (nowMs - entry.atMs > KEEP_MS) { kept.delete(keyOf(key)); return null; }
    return entry.reads;
}

export function _resetKeptReadsForTests() {
    kept.clear();
}
